/********************************************
 * Featured Projects
*
********************************************/
function fnFeaturedProjects( i, oSection ) {

	/*****************
	* Objects
	*****************/
	var oSection				= $( oSection ),
		oMenu				= $( '.distort-menu', oSection ),
		oMenuItem					= $( '.distort-menu-item', oSection );


	if ($('.distort-wrap').length) {
		new Menu();
	}

	function distortSection() {
		if ( window.innerWidth >= 1025 && $( '.distort-on-scroll' ).length ) {
			$( '.distort-on-scroll' ).each( function() {
				var $cont = $( this ).find( '.cell' );
				var perspective = 'perspective(500px) ';
				var winH = window.innerHeight;
				$( window ).on( 'scroll', function() {
					var elPos = $cont[0].getBoundingClientRect();
					if ( elPos.top < winH ) {
						var angleRatio = (-elPos.top / (winH * 0.4)) + 1;
						angleRatio = angleRatio < 0 ? 0 : angleRatio;
						angleRatio = angleRatio > 1 ? 1 : angleRatio;

						var scaleVal = angleRatio * 0.2 + 1;
						var rotate = ' rotateX(' + angleRatio * 10 + 'deg)';
						var scale = ' scaleX(' + scaleVal + ')';
						$cont.css( {
							transform: perspective + rotate + scale
						} );
					}
				} );
			} );
		}
	}

	/*****************
	* Scripts which runs on scrolling
	*****************/

	var lastScrollTop = 0, resetSkew;
	$( window ).on( 'scroll', function() {


		if ( !$( 'html' ).hasClass( 'no-supports' ) ) {
			// Scroll Decor
/*
			scrollDecor();

			// Parallax
			parallaxScroll();
*/

			distortSection();
		}

		if ( $( '.distort-menu-item' ).length ) {

			if ( resetSkew ) clearTimeout( resetSkew );

			resetSkew = setTimeout( function() {
				$( '.distort-menu-item' ).removeClass( 'skew-cw skew-ccw' );
			}, 700 );

			var scrollTop = $( window ).scrollTop();
			if ( scrollTop == 0 || (scrollTop + $( window ).height() == $( document ).height()) ) {
				$( '.distort-menu-item' ).removeClass( 'skew-cw skew-ccw' );
			} else {
				if ( $( window ).scrollTop() > lastScrollTop ) {
					$( '.distort-menu-item' ).removeClass( 'skew-cw' ).addClass( 'skew-ccw' );
				} else {
					$( '.distort-menu-item' ).addClass( 'skew-cw' ).removeClass( 'skew-ccw' );
					// upscroll code
				}
			}

			lastScrollTop = $( window ).scrollTop() <= 0 ? 0 : $( window ).scrollTop();
		}

	} );



}


// END OF DOCUMENT
